import { render } from "./_photo.vue?vue&type=template&id=39d94cd3&ts=true"
import script from "./_photo.vue?vue&type=script&lang=ts"
export * from "./_photo.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./_photo.vue?vue&type=style&index=0&id=39d94cd3&lang=scss&module=true"
cssModules["$style"] = style0
import "./_photo.vue?vue&type=style&index=1&id=39d94cd3&lang=scss"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__